import { MEDSCAPE_API_BASE_URL_V5, MEDSCAPE_API_BASE_URL_V7 } from '../config';

export const MedscapeAPIRoutes = {
  dictionaries: () => `${MEDSCAPE_API_BASE_URL_V5}/dictionaries`,
  dictionariesV7: () => `${MEDSCAPE_API_BASE_URL_V7}/dictionaries`,
};
